import GraphqlBuilder from "utils/request/graphql/builder";
import _ from "lodash";
import MutationEmployeeStoreReview from 'graphql/mutations/MutationEmployeeStoreReview'
import EmployeeValues from 'scenes/home/more/_functions/Employee'
import HelperDate, { dateFormat } from 'utils/helper-date'

export default class MutateEmployeeStoreReview {

	static mutate = ( { callbackSuccess = null, callbackError = null, callbackStart = null } ) => {
		const graphqlBuilder = new GraphqlBuilder();
		
		graphqlBuilder.addQuery( `mutation-employee-store-review`, MutationEmployeeStoreReview, {
			store_review_datetime: HelperDate.date().format( dateFormat.DATE_PRETTY ),
		});
		
		graphqlBuilder.setOnStart( callbackStart )
		graphqlBuilder.setOnError( callbackError );

		graphqlBuilder.setOnSuccess( result => {
			// Reload the employee
			EmployeeValues.reloadEmployee();
			
			if( _.isFunction( callbackSuccess ) ) {
				callbackSuccess( result )
			}
		})
		
		graphqlBuilder.execute();
	}
}
